import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Visualiser from './Visualiser/Visualiser';

function App() {
  return (
    <div className="App">
      <Visualiser></Visualiser>
    </div>
  );
}

export default App;
